<template>
  <div v-if="load">
    <scale-loader/>
  </div>

  <tabs v-else-if="server_is_load" parent="server">
    <tab id="info" :name="translate('server.section.info')" :href="url+'/info'">
      <ServerInfo v-if="server_is_load"
        :server="server_info"
        @update="get_server"
      />
    </tab>
  </tabs>

  <div v-else>
    <div class="wrapper-full-page section content">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-md-offset-2 text-center">
            <h2 class="title text-danger">
              Client Order: {{cur_id}} not found
            </h2>
            <router-link :to="{path:'/server_list/list'}">
              To Client Orders list
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import {Tabs, Tab} from 'components/UIComponents/Tabs'
import ServerInfo from './Tabs/Info/Index.vue'

export default {
  name: 'Server',
  components: {
    ServerInfo,
    Tab,
    Tabs,
  },
  data () {
    return {
      section: 'info',
      server_info: null,
    }
  },

  computed: {
    url () { return '/server/' + this.$route.params.server_id },
    cur_id () { return this.$route.params.server_id },
    load () { return !this.server_info?.id },
    server_is_load() { return this.server_info !== null }
  },
  watch: {
    cur_id () {
      if (this.cur_id && this.$route.name === 'server_section') {
        this.get_server()
      }
    }
  },

  activated(){
    this.get_server()
  },

  methods: {
    get_server () {
      this.$http.v1.getServerInfo(this.$route.params.server_id, (response) => {
        this.server_info = response.data
      })
    }
  }
}

</script>
